<template>
  <layout-page :nav-bar-show-logo-text="false">
    <page-breadcrumb :hierarchy="breadCrumbs"/>

    <div class="container" v-if="loading">
      <span class="text-4xl">Loading form......</span>
    </div>

    <div class="container" v-else-if="!success && agency && !failed">
      <h1
        class="font-large mb-4 text-2xl font-extrabold text-blue lg:text-left lg:text-3xl"
      >
        Agency Callback Request
      </h1>
      <div class="flex flex-col gap-2 text-grey-90">
        <p>
          Enter the details of your requirements to arrange a callback from
          <span class="font-bold">{{ agency.Name }}</span>
        </p>
      </div>

      <EmployerCallbackForm
        :submitting="submitting"
        :errors="errors"
        :job-title="parameters.jobTitle"
        :job-location="parameters.jobLocation"
        :employment-type="parameters.employmentType"
        :company-name="parameters.companyName"
        :email="parameters.email"
        :contact-name="parameters.contactName"
        :phone-number="parameters.phoneNumber"
        :contact-other-agencies="parameters.contactOtherAgencies"
        @changeParameter="(payload) => setParameter(payload)"
        @submit="submitEmployerCallbackForm"
      />
    </div>

    <div class="container" v-else-if="success">
      <h1
        class="font-large mb-4 text-2xl font-extrabold text-blue lg:text-left lg:text-3xl"
      >
        Success!
      </h1>
      <AcCard class="mb-4 bg-green-10 p-4 text-lg font-bold text-white">
        Thank You - Your details have been submitted to Agency Central
      </AcCard>

      <InputButton @click="handleCloseWindow" styleType="primary"
        >Close Window</InputButton
      >
    </div>

    <div class="container" v-else-if="failed">
      <AcCard class="bg-red-300 p-4">
        <h1 class="text-2xl font-bold">An error has occurred</h1>
        <p>
          We're currently unable to handle your callback request. Contact Agency
          Central on
          <a
            class="text-blue hover:text-blue-70 hover:underline"
            href="mailto:customersupport@agencycentral.co.uk"
            >customersupport@agencycentral.co.uk</a
          >
          for further assistance with your enquiry.
        </p>
      </AcCard>
    </div>
  </layout-page>
</template>

<script>
import IconChevronRight from 'Components/Icons/IconChevronRight.vue';
import LayoutPage from 'Components/layouts/LayoutPage.vue';
import PageBreadcrumb from 'Components/PageBreadcrumb.vue';
import InputButton from 'Components/InputButton.vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import AcCard from 'Components/AcCard.vue';
import EmployerCallbackForm from 'Components/FormEmployerCallback.vue';
import SearchService from 'Services/SearchService';

export default {
  name: 'EmployerCallback',
  components: {
    EmployerCallbackForm,
    AcCard,
    PageBreadcrumb,
    InputButton,
    LayoutPage,
    IconChevronRight,
  },
  computed: {
    ...mapState('employerCallback', [
      'agency',
      'errors',
      'failed',
      'loading',
      'parameters',
      'submitting',
      'success',
    ]),
    breadCrumbs : function(){
      return [
        {
          name: 'Agency Callback Request'
        }
      ]
    }
  },
  methods: {
    ...mapActions('employerCallback', ['submitEmployerCallbackForm']),
    ...mapMutations('employerCallback', [
      'setParameter',
      'setAgency',
      'resetState',
      'setLoading',
    ]),
    handleCloseWindow() {
      window.close();
    },
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      vm.setParameter({ key: 'searchUrl', value: document.referrer });
      vm.setParameter({ key: 'agency', value: to.query.agency });
      const selectedAgency = await SearchService.getSingle(to.query.agency);
      if (selectedAgency) {
        vm.setAgency(selectedAgency);
      }
      vm.setLoading(false);
    });
  },
  mounted() {
    this.resetState();
  },
};
</script>
